import axios from 'axios'

class PlanService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Leonel Contreras
  * @description Handle event to get the information about a plans asigned to Mifirma from A3cloud
  * @date 20-07-2020
  * @param {String} token
  * @returns {Object}
  * @memberof PlanService
  */
  async getPlanService(token) {
    let response = await axios.get(`${this.apiUrl}/plan-pricing`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
  * @author Alan Aguilar
  * @description Handle event to get the information a contract and plan of a user sesion from hibou.legal and A3cloud
  * @date 11-09-2020
  * @param {String} token
  * @returns {Object}
  * @memberof PlanService
  */
  async getUserContractAndPlan(token) {
    const resp = await axios.get(`${this.apiUrl}/plan-user`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).then(function (response) {
      return response.data
    }).catch(function (error) {
      return { response: 'error', data: error }
    })
    return resp
  }
}

export { PlanService as default }
